import React from 'react'
import { Link, Navigate, NavLink, useLocation } from 'react-router-dom'
import { useAppSelector } from '../Redux/hooks'
import SplashScreen from '../Scenes/Loading/SplashScreen';
import NotFound from '../Scenes/NotFound/NotFound';


interface WrapperProps {
    children: JSX.Element;
    roles: string[];
}

export const PrivateWrapper = ({ children, roles }: WrapperProps) => {

    const user = useAppSelector(x => x.user);
    const { pathname } = useLocation();

    React.useEffect(() => {
        //console.log("Entered private rue");
    }, [user.token]);

    //console.log("in wrapper", user)

    //const userHasRequiredRole = (user && user.resourceGroup != null && roles.includes(user.resourceGroup)) ? true : false;
//
    //if (user.token != null && roles.length > 0 && !userHasRequiredRole) {
//
    //    return <NotFound displayText="Geen toegang" />
    //}
    if (user.token != null) {
        //console.log("returning children with user:",user)
        return children;
    }



    //not authenticated
    return (<Navigate to="/login" state={{ from: pathname }} />);
};
